export const CHAT_CONSTANTS = {
  WIDTH_KEY: 'chat-width',
  MIN_WIDTH: 300,
  MAX_WIDTH: 1600,
} as const;

export const MESSAGE_CONSTANTS = {
  ID_SEPARATOR: '-',
  ID_RANDOM_LENGTH: 9,
  CODE_BLOCK_REGEX: /```[\w]*\n([\s\S]*?)\n```/g,
} as const;

export const THREAD_CONSTANTS = {
  THREAD_ID_PREFIX: 'thread-',
  DEFAULT_AGENT_TYPE: 'chat_agent',
} as const;

export const TRANSLATION_KEYS = {
  AGENTS: {
    DEFAULT_ASSISTANT_NAME: 'chat.agents.default-assistant-name',
    VALIDATION_FAILED: 'chat.agents.errors.validation-failed',
    DEFAULT_DESCRIPTION: 'chat.agents.default.description',
  },
  THREADS: {
    UNTITLED_THREAD: 'chat.threads.untitled-thread',
    DEFAULT_TITLE: 'chat.threads.default-title',
    NEW_THREAD: 'chat.threads.new-thread',
    DELETE_CONFIRMATION: {
      TITLE: 'chat.threads.delete-confirmation.title',
      MESSAGE: 'chat.threads.delete-confirmation.message',
      WARNING: 'chat.threads.delete-confirmation.warning',
      CANCEL: 'chat.threads.delete-confirmation.cancel',
      DELETE: 'chat.threads.delete-confirmation.delete',
    },
  },
  MESSAGES: {
    YOU: 'chat.messages.you',
  },
} as const;

export const API_ENDPOINTS = {
  HEALTH: '/api/v1/health',
  APPS: '/api/v1/apps',
  THREADS: '/api/v1/threads',
  RUN_APP: '/api/v1/run',
} as const;

export const HTTP_HEADERS = {
  CONTENT_TYPE: 'application/json',
  ACCEPT: 'application/json, text/plain, */*',
  X_REQUESTED_WITH: 'XMLHttpRequest',
  AUTHORIZATION_PREFIX: 'Bearer ',
} as const;

export const EDITOR_CONSTANTS = {
  THEMES: {
    VS_DARK: 'vs-dark',
    VS: 'vs',
  },
  LANGUAGES: {
    PYTHON: 'python',
    SQL: 'sql',
    JAVASCRIPT: 'javascript',
    TYPESCRIPT: 'typescript',
    JSON: 'json',
    TEXT: 'text',
  },
  MODES: {
    EDITING: 'editing',
    DISPLAY: 'display',
    DIFF: 'diff',
    CONTEXT: 'context',
  },
} as const;

export const STATUS_CONSTANTS = {
  HEALTHY: 'healthy',
  UNHEALTHY: 'unhealthy',
} as const;

export const ROLE_CONSTANTS = {
  USER: 'user',
  ASSISTANT: 'assistant',
} as const;